import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { type MaybeRefOrGetter, toValue } from 'vue'
import { useApi } from '@/composables/api'

type AuthenticationBody = { username: string, password: string, useCookie: boolean }

const { sendPostRequest } = useApi()

export function useAuthentication() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ username, password } : { username: MaybeRefOrGetter<string>, password: MaybeRefOrGetter<string> }) => {
      try {
        const { response } = await sendPostRequest<unknown, AuthenticationBody>('authentication/tokens', {
          username: toValue(username),
          password: toValue(password),
          useCookie: true
        })

        return response.ok
      } catch (e: unknown) {
        return false
      }
    },
    onSuccess: async (authenticated) => {
      if (!authenticated) {
        return
      }

      await queryClient.invalidateQueries()
    }
  })

  return { authenticate: mutation.mutateAsync, isPending: mutation.isPending }
}